import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import setupIndexedDB from "use-indexeddb";

import React, { useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import PrivateRoute from "./components/PrivateRoute";
import messages_cs from "./languages/cs.json";
import messages_de from "./languages/de.json";
import messages_en from "./languages/en.json";
import messages_es from "./languages/es.json";
import messages_fr from "./languages/fr.json";
import messages_it from "./languages/it.json";
import messages_ja from "./languages/ja.json";
import messages_nl from "./languages/nl.json";
import messages_pl from "./languages/pl.json";
import messages_zh from "./languages/tw.json";
import messages_sk from "./languages/sk.json";
import AdminMenu from "./pages/Admin/AdminMenu";
import ChoiceDefaultTemplate from "./pages/Admin/ChoiceDefaultTemplate";
import Inputs from "./pages/Admin/Inputs";
import UserManagement from "./pages/Admin/UserManagement";
import Login from "./pages/Login";
import "./styles/components.scss";

import GeneralCountry from "./pages/Admin/GeneralCountry";
import ManageTemplates from "./pages/Admin/ManageTemplates";

import { idbConfig } from "./components/dbConfig";

import NotResponsive from "./components/NotResponsive";
import ResultsStore from "./DataStores/ResultsStore";
import SettingStore from "./DataStores/SettingStore";
import ToolStore from "./DataStores/ToolStore";
import NewVersion from "./pages/ROI/NewVersion";
import Settings from "./pages/Settings/Settings";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import axios from "axios";
import { msalConfig } from "../src/pages/authConfig";
import withClearCache from "./ClearCache";
import AzureStore from "./DataStores/AzureStore";
import ChartPage from "./pages/ChartPage";
import NewTool from "./pages/ROI/NewTool";
import Complain from "./pages/Settings/Complain";
import Forms from "./pages/Settings/Forms";
import General from "./pages/Settings/General";
import GmailCode from "./pages/Settings/GmailCode";
import History from "./pages/Settings/History";
import HistoryAdmin from "./pages/Settings/HistoryAdmin";
import { togetCurrentUser, toGetSettingsUser } from "./utils/APIs";
import { getLanguage } from "./utils/Utils";

const messages = {
  fr: messages_fr,
  en: messages_en,
  es: messages_es,
  it: messages_it,
  cs: messages_cs,
  nl: messages_nl,
  de: messages_de,
  pl: messages_pl,
  th: messages_zh,
  ja: messages_ja,
  sk: messages_sk,
};
var language = getLanguage();
const ClearCacheComponent = withClearCache(MainApp);

function App() {
  return <ClearCacheComponent />;
}
function MainApp() {
  const [role, setRole] = useState(null);
  useEffect(() => {
    toGetSettingsUser().then((res) => {
      if (null != res) {
        SettingStore.setFontSize(res.fontSize);
        SettingStore.setTemplateId(res.templateId);
      } else {
        SettingStore.setFontSize(1);
      }
    });
  }, []);
  useEffect(() => {
    togetCurrentUser().then((res) => {
      ToolStore.setUser(res);
      setRole(res.type ?? "");
    });
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined" && window.indexedDB) {
      setupIndexedDB(idbConfig)
        .then(() => console.log("success"))
        .catch((e) => console.error("error", e));
    }
  }, []);

  return (
    <IntlProvider defaultLocale={"en"} messages={messages[language]}>
      <BrowserRouter>
        <Routes>
          <Route
            path="/history"
            element={
              <PrivateRoute ToolStore={ToolStore}>
                <History />
              </PrivateRoute>
            }
          />

          {role === "admin" && (
            <Route
              path="/list"
              element={
                <PrivateRoute ToolStore={ToolStore}>
                  <HistoryAdmin />
                </PrivateRoute>
              }
            />
          )}
          <Route
            path="/forms"
            element={
              <PrivateRoute ToolStore={ToolStore}>
                <Forms />
              </PrivateRoute>
            }
          />
          <Route
            path="/general"
            element={
              <PrivateRoute ToolStore={ToolStore}>
                <General SettingStore={SettingStore} />
              </PrivateRoute>
            }
          />

          <Route
            path="/newversion"
            element={
              <PrivateRoute ToolStore={ToolStore}>
                <NewVersion ToolStore={ToolStore} />
              </PrivateRoute>
            }
          />
          {role == "admin" && (
            <Route
              path="/inputs"
              element={
                <PrivateRoute ToolStore={ToolStore}>
                  <Inputs />
                </PrivateRoute>
              }
            />
          )}
          <Route
            element={
              <PrivateRoute ToolStore={ToolStore}>
                <AdminMenu ToolStore={ToolStore} />
              </PrivateRoute>
            }
            exact
            path="/admin"
            SettingStore={SettingStore}
          />
          {role == "admin" && (
            <Route
              path="/userManagement"
              element={
                <PrivateRoute ToolStore={ToolStore}>
                  <UserManagement />
                </PrivateRoute>
              }
            />
          )}
          <Route
            path="/choice"
            element={
              <PrivateRoute ToolStore={ToolStore}>
                <ChoiceDefaultTemplate
                  setSelectedChoice={() => {}}
                  showHeader={true}
                />
              </PrivateRoute>
            }
          />
          {role == "admin" && (
            <Route
              path="/manageTemplates"
              element={
                <PrivateRoute ToolStore={ToolStore}>
                  <ManageTemplates ToolStore={ToolStore} />
                </PrivateRoute>
              }
            />
          )}
          <Route
            path="/generalCountry"
            element={
              <PrivateRoute ToolStore={ToolStore}>
                <GeneralCountry />
              </PrivateRoute>
            }
          />
          <Route
            path="/tool"
            element={
              <PrivateRoute ToolStore={ToolStore}>
                <NewTool
                  SettingStore={SettingStore}
                  ToolStore={ToolStore}
                  ResultsStore={ResultsStore}
                />
              </PrivateRoute>
            }
          />
          <Route
            path="/results"
            element={
              <PrivateRoute ToolStore={ToolStore}>
                <ChartPage ResultsStore={ResultsStore} />
              </PrivateRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <PrivateRoute ToolStore={ToolStore}>
                <Settings />
              </PrivateRoute>
            }
          />

          <Route
            path="/complain"
            element={
              <PrivateRoute ToolStore={ToolStore}>
                <Complain />
              </PrivateRoute>
            }
          />
          <Route
            path="/success*"
            element={
              <PrivateRoute ToolStore={ToolStore}>
                <GmailCode />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/login"
            element={<Login AzureStore={AzureStore} />}
          />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
      <NotResponsive />
    </IntlProvider>
  );
}

export default App;
